import { render, staticRenderFns } from "./TimelineEvent.vue?vue&type=template&id=5a7529a2&scoped=true"
import script from "./TimelineEvent.vue?vue&type=script&lang=js"
export * from "./TimelineEvent.vue?vue&type=script&lang=js"
import style0 from "./TimelineEvent.vue?vue&type=style&index=0&id=5a7529a2&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a7529a2",
  null
  
)

export default component.exports